import standardAPI from '@/api/standard_items';

const state = {
  tours: [],
  tours_status: '',
  tours_MetaData: {},
  tours_page: 1,
  tours_perPage: 10,
};

const responseUrl = '/organisation-tours/tours';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_tours ({ commit }, getOptions) {
    commit('TOURS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('TOURS_SUCCESS', response);
            commit('TOURS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('TOURS_READY');
            reject(response);
          } else {
            commit('TOURS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_tours_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_tour ({ commit, dispatch }, itemData) {
    commit('TOURS_REQUEST');
    console.log('itemData',itemData)
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('TOURS_READY');
          reject(response);
        }
      });
    });
  },
  edit_tour ({ commit, dispatch }, itemData) {
    commit('TOURS_REQUEST');
    console.log('itemData',itemData)
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('TOURS_READY');
          reject(response);
        }
      });
    });
  },
  remove_tour ({ commit, dispatch }, itemData) {
    commit('TOURS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('TOURS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_tour ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_tour_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.tours_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.tours_perPage = max;
  },
  TOURS_READY: (state) => {
    state.tours_status = 'ready';
  },
  TOURS_REQUEST: (state) => {
    state.tours_status = 'loading';
  },
  TOURS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.tours_MetaData.meta = response.meta;
      state.tours_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.tours = response.data.map((tour) => {
        tour.checked = false; // need for some pages where we can select tours
        return tour;
      }) || [];
    }
    state.tours_status = 'success';
  },
  TOURS_ERROR: (state) => {
    state.tours_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
